import React from 'react';
import UserLayout from '../layout/UserLayout';

const UserActivity = () => {
  return <></>;
};

export default UserLayout(UserActivity);
